import Vue from 'vue'
import Vuex from 'vuex'
import { initApi } from './api.js'
import urljoin from 'url-join'
import { initModules } from './store/index'
import serialize from 'form-serialize'

Vue.use(Vuex)

export function createStore({ axios }) {
  const api = initApi(axios)
  const { users, news, campaigns, voting, events, elections } = initModules(axios, api)

  const store = new Vuex.Store({
    modules: {
      users,
      news,
      campaigns,
      voting,
      events,
      elections
    },

    state: {
      drawer: false,
      isCordova: false,
      loading: false,
      mobileMenuToggled: false,
      items: {},
      hero: '',
      tabs: [],
      pagesTotal: 0,
      title: '',
      page: {
        title: {
          rendered: false
        },
        content: null
      },
      chartColors: [
        '#FFAD19', '#369E66', '#57B281', '#5A3773', '#86B0E1',
        '#BF64FF', '#95E1B5', '#9CB2A6', '#FFD690', '#C46196'
      ],
      qrScanner: false,
      error: {
        show: false,
        message: '',
      },
      alert: {
        show: false,
        type: 'info',
        message: '',
      }
    },

    getters: {
      drawer: state => state.drawer,
      isCordova: state => state.isCordova,
      loading: state => state.loading,
      mobileMenuToggled: state => state.mobileMenuToggled,
      page: state => state.page,
      pagesTotal: state => state.pagesTotal,
      chartColors: state => state.chartColors,
      isBrowser: () => isBrowser,
      route: state => state.route,
      qrScanner: state => state.qrScanner,
      error: state => state.error,
      alert: state => state.alert,
      hero: state => state.hero,
      tabs: state => state.tabs,
      title: state => state.title
    },

    actions: {
      getPage({ commit }, slug) {
        return api.fetchPage(slug).then(page => {
          commit('setPage', page)
          commit('setHero', page.thumbnail)
        })
      },

      qrScan() {
        return new Promise((resolve, reject) => {
          window.cordova.plugins.barcodeScanner.scan(
            contents => resolve(JSON.parse(contents.text)),
            err => reject(err),
            {
              disableSuccessBeep: true,
              prompt: 'Поставете QR кода в полето за сканиране.'
            }
          )
        })
      },

      submitForm({ commit }, form) {
        const submitBtn = form.querySelectorAll('input[type="submit"]')[0]
        submitBtn.disabled = true

        const data = serialize(form)
        const formId = form.querySelectorAll('input[name="_wpcf7"]')[0].value

        api.postForm(formId, data).then(res => {
          if (res.data.status === 'mail_sent') {
            commit('setError', { title: '', body: `<p>${res.data.message}</p>`, show: true })
            submitBtn.disabled = false
          } else {
            let errorMsg = `<p>${res.data.message}</p>`
            if (res.data.invalidFields) {
              res.data.invalidFields.forEach(field => (errorMsg += `<p>${field.message}</p>`))
            }
            commit('setError', { title: 'Грешка', body: errorMsg, show: true })
            submitBtn.disabled = false
          }
        })
      }
    },

    mutations: {
      setHero: (state, hero) => (state.hero = hero),
      clearHero: state => (state.hero = ''),
      setTabs: (state, tabs) => {
        return state.tabs = tabs
      },
      clearTabs: state => (state.tabs = []),
      setTitle: (state, title) => (state.title = title),
      clearTitle: state => (state.title = ''),
      setPagesTotal: (state, pagesTotal) => (state.pagesTotal = pagesTotal),

      setLoading(state, loading) {
        state.loading = loading
      },

      toggleDrawer(state, isOpen) {
        state.drawer = isOpen
      },

      showError(state, message) {
        state.error.message = message
        state.error.show = true
      },

      clearError(state) {
        state.error.message = ''
        state.error.show = false
      },

      showAlert(state, { type, message, dismissible }) {
        state.alert.message = message
        state.alert.type = type
        state.alert.show = true
        state.alert.dismissible = typeof dismissible === 'undefined' ? true : dismissible
      },

      clearAlert(state) {
        state.alert.message = ''
        state.alert.show = false
      },

      toggleMobileMenu(state) {
        state.mobileMenuToggled = !state.mobileMenuToggled
      },

      setPage(state, page) {
        state.page = page
      },
    }
  })

  const isBrowser = typeof window.cordova === 'undefined'

  // if logged in, use the auth token
  axios.interceptors.request.use((config) => {
    if (typeof process.env.VUE_APP_API_URL !== 'undefined') {
      config.url = urljoin(process.env.VUE_APP_API_URL, config.url)
    }

    // config.url = isBrowser ? '/' : 'https://app.dabulgaria.bg/'
    if (store.getters.loggedIn && store.getters.authToken) {
      config.headers = { 'Authorization': 'Bearer ' + store.getters.authToken }
    }
    return config
  })

  return store
}
